module.exports = __webpack_public_path__ + "f851bce4.svg";